// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutBucketingBar-cls1_pG4","cls2":"LoggedOutBucketingBar-cls2_BMm LoggedOutBucketingBar-cls1_pG4"};